export default "__VITE_ASSET__0e44e417__"